import Model from '@/models/Model.js';

export default class Attendance extends Model {
    static entity = 'attendances';

    static modelName = 'Attendance';

    static fields() {
        return {
            id: this.attr(null),
            course_id: this.attr(null),
            time_period_id: this.attr(null),
            enrollment_group_id: this.attr(null),
            user_id: this.attr(null),
            notified: this.attr(null),
            notes: this.attr(null),
            message: this.attr(null),
            credit_time_earned: this.attr(null),
            clock_time_earned: this.attr(null),
            checked_in_at: this.attr(null),
            checked_out_at: this.attr(null),
            break_time: this.attr(null),
            comments_count: this.number(0),

            ...super.fields(),

            course: this.belongsTo('courses', 'course_id'),
            time_period: this.belongsTo('time_periods', 'time_period_id'),
            enrollment_group: this.belongsTo('enrollment_groups', 'enrollment_group_id'),
            user: this.belongsTo('users', 'user_id'),
            comments: this.hasMany('attendance_comments', 'attendance_id'),
        };
    }

    get has_check_in_dates() {
        return this.checked_in_at && this.checked_out_at;
    }

    get tooltip() {
        return `${this.timestamp('checked_in_at').format('LLL zz')} - ${this.timestamp('checked_out_at').format(
            'LLL zz'
        )}`;
    }

    get clock_time_minutes_earned() {
        return this.clock_time_earned / 60;
    }

    get clock_time_hours_earned() {
        return this.clock_time_earned / 3600;
    }

    get style() {
        return this.enrollment_group?.style;
    }
}
